const PrivacyPolicy = () => {
  return (
        <div className="container py-5 privacy-policy">
            <h1>Privacy Policy</h1>
            <p><strong>Effective Date:</strong> September 1st, 2024</p>
            <p>
                Welcome to Pulse, a time-tracking application provided by Loopboard Inc.  (&quot;Company&quot;, &quot;we&quot;, &quot;our&quot;, or &quot;us&quot;) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our time-tracking application, Pulse (&quot;Service&quot;). By using the Service, you agree to the collection and use of information in accordance with this Privacy Policy.
            </p>

            <h2>1. Information We Collect</h2>
            <h3>1.1 Personal Information</h3>
            <p>
                When you create an account or use the Service, we may collect certain personal information that can be used to identify you, such as:
            </p>
            <ul>
                <li>Name</li>
                <li>Email address</li>
                <li>Payment information (for paid subscriptions)</li>
                <li>Business information (e.g., company name, role)</li>
            </ul>

            <h3>1.2 Usage Data</h3>
            <p>
                We may collect information on how the Service is accessed and used (&quot;Usage Data&quot;). This Usage Data may include information such as your device&apos;s Internet Protocol address (e.g., IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other diagnostic data.
            </p>

            <h3>1.3 Cookies and Tracking Technologies</h3>
            <p>
                We use cookies and similar tracking technologies to track the activity on our Service and hold certain information. Cookies are files with small amounts of data that may include an anonymous unique identifier. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service. You can find out more about cookies and how to control them in the <a href="/cookie-policy">Cookie Policy</a>.
            </p>

            <h2>2. How We Use Your Information</h2>
            <p>
                Loopboard Inc. uses the collected data for various purposes:
            </p>
            <ul>
                <li>To provide, operate, and maintain our Service</li>
                <li>To improve, personalize, and expand our Service</li>
                <li>To understand and analyze how you use our Service</li>
                <li>To develop new products, services, features, and functionality</li>
                <li>To process your transactions and manage your subscriptions</li>
                <li>To communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the Service, and for marketing and promotional purposes</li>
                <li>To find and prevent fraud</li>
                <li>To comply with legal obligations</li>
            </ul>
            <h2>3. How We Share Your Information</h2>
            <h3>3.1 Service Providers</h3>
            <p>
                We may employ third-party companies and individuals to facilitate our Service (&quot;Service Providers&quot;), provide the Service on our behalf, perform Service-related services, or assist us in analyzing how our Service is used. These third parties have access to your personal information only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
            </p>

            <h3>3.2 Legal Requirements</h3>
            <p>
                Loopboard Inc. may disclose your personal information in the good faith belief that such action is necessary to:
            </p>
            <ul>
                <li>Comply with a legal obligation</li>
                <li>Protect and defend the rights or property of Loopboard Inc.</li>
                <li>Prevent or investigate possible wrongdoing in connection with the Service</li>
                <li>Protect the personal safety of users of the Service or the public</li>
                <li>Protect against legal liability</li>
            </ul>

            <h3>3.3 Business Transfers</h3>
            <p>
                If Loopboard Inc. is involved in a merger, acquisition, or asset sale, your personal information may be transferred. We will provide notice before your personal information is transferred and becomes subject to a different Privacy Policy.
            </p>

            <h2>4. Data Security</h2>
            <p>
                We value your trust in providing us with your personal information, and we strive to use commercially acceptable means to protect it. However, no method of transmission over the internet, or method of electronic storage is 100% secure, and we cannot guarantee its absolute security.
            </p>

            <h3>4.1 Security Measures</h3>
            <p>
                We employ a variety of security measures, including encryption, access controls, and secure server technology, to ensure that your personal information is protected from unauthorized access, use, or disclosure.
            </p>

            <h3>4.2 Breach Notification</h3>
            <p>
                In the unlikely event of a data breach, we will notify affected users as required by applicable laws and regulations. We will also take all necessary steps to mitigate the breach and prevent future occurrences.
            </p>

            <h2>5. Data Retention</h2>
            <p>
                We will retain your personal information only for as long as necessary to fulfill the purposes for which it was collected, or as required by law.
            </p>

            <h3>5.1 Retention Period</h3>
            <p>
                The retention period for personal information will vary depending on the nature of the data and the purpose for which it was collected. For example, we may retain your account information for as long as your account is active and for a reasonable period afterward in case you decide to re-activate the Service.
            </p>

            <h3>5.2 Deletion</h3>
            <p>
                If you wish to delete your personal information from our systems, you can do so by contacting us at info@loopboard.io. We will take reasonable steps to ensure your data is securely deleted unless we are required by law to retain it.
            </p>

            <h2>6. User Rights</h2>
            <h3>6.1 Access and Correction</h3>
            <p>
                You have the right to access and correct the personal information we hold about you. If you believe any information is inaccurate or incomplete, please contact us to update it.
            </p>

            <h3>6.2 Data Portability</h3>
            <p>
                You have the right to request a copy of your personal information in a structured, commonly used, and machine-readable format. You may also request that we transfer this data to another service provider where technically feasible.
            </p>

            <h3>6.3 Right to Erasure</h3>
            <p>
                You have the right to request that we delete your personal information, subject to certain exceptions, such as where we need to retain the data to comply with legal obligations.
            </p>

            <h3>6.4 Right to Object</h3>
            <p>
                You have the right to object to certain processing of your personal information, including processing for direct marketing purposes. If you object, we will stop processing your information for those purposes.
            </p>

            <h2>7. Children’s Privacy</h2>
            <p>
                Our Service is not intended for use by anyone under the age of 16 (&quot;Children&quot;). We do not knowingly collect personally identifiable information from children under 16. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us. If we become aware that we have collected personal information from children without verification of parental consent, we take steps to remove that information from our servers.
            </p>

            <h2>8. International Data Transfers</h2>
            <p>
                Your information, including personal information, may be transferred to — and maintained on — computers located outside of your state, province, country, or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.
            </p>

            <h3>8.1 Transfer Mechanisms</h3>
            <p>
                If you are located outside the United States and choose to provide information to us, please note that we transfer the data, including personal information, to the United States and process it there. We will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy.
            </p>

            <h2>9. Changes to This Privacy Policy</h2>
            <p>
                We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
            </p>

            <h3>9.1 Policy Updates</h3>
            <p>
                We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective, and update the &quot;Effective Date&quot; at the top of this Privacy Policy.
            </p>

            <h3>9.2 User Consent</h3>
            <p>
                Your continued use of the Service after any changes to this Privacy Policy signifies your acceptance of those changes.
            </p>

            <h2>10. Contact Information</h2>
            <p>
                If you have any questions about this Privacy Policy, please contact us:
            </p>
            <p>
                <strong>Loopboard Inc.</strong><br />
                1111B S Governors Ave STE 21944<br />
                Dover, DE 19904<br />
                Email: info@loopboard.io<br />
                Phone: (786) 605-8053
            </p>

            <h2>11. Third-Party Links</h2>
            <p>
                Our Service may contain links to other sites that are not operated by us. If you click on a third-party link, you will be directed to that third party&apos;s site.
            </p>
        </div>
  )
}

export default PrivacyPolicy
